export default {
      id: "sli-move-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-move",
      toString: function () {
        return this.url;
      }
    }